module.exports = __webpack_public_path__ + "img/premium_dealer_logo_en.8b4693e4.png";